import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import FortuneForm from "./components/FortuneForm";
import Footer from "./components/Footer";
import ScrollOrders from "./components/ScrollOrders";

export default function Home() {
  const [navBg, setNavBg] = useState(false);
  const [searchParams] = useSearchParams();

  // 解析广告参数并保存映射关系
  useEffect(() => {
    // 1. 快手广告 callback（同时支持 callback 和 kuaishou_callback 两种参数名）
    // 按快手官方文档，落地页宏替换参数名为 callback（即 __CALLBACK__ 宏）
    const kuaishouCallback =
      searchParams.get("callback") ||
      searchParams.get("kuaishou_callback");
    if (kuaishouCallback) {
      localStorage.setItem("kuaishou_callback", kuaishouCallback);
      console.log("[HomePage] 保存快手广告 callback:", kuaishouCallback.substring(0, 50));
    }

    // 2. 转化宝 customer_channel 参数
    // 格式：ys-75-标识ID-备注
    const customerChannel = searchParams.get("customer_channel");
    if (customerChannel) {
      localStorage.setItem("customer_channel", customerChannel);
      // 提取标识ID（格式第三段）
      const parts = customerChannel.split("-");
      const channelId = parts.length >= 3 ? parts[2] : customerChannel;
      localStorage.setItem("channel_id", channelId);
      console.log("[HomePage] 转化宝 channel:", customerChannel, "标识ID:", channelId);

      // 向后端保存映射关系（channel_id ↔ kuaishou_callback）
      const savedCallback = kuaishouCallback || localStorage.getItem("kuaishou_callback") || "";
      fetch(`${import.meta.env.VITE_PUBLIC_SUPABASE_URL}/functions/v1/zhuanhuabao-notify`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "apikey": import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY,
        },
        body: JSON.stringify({
          channel_id: channelId,
          channel_raw: customerChannel,
          kuaishou_callback: savedCallback,
        }),
      }).catch((e) => console.error("[HomePage] 保存映射失败:", e));
    }
  }, [searchParams]);

  useEffect(() => {
    const onScroll = () => setNavBg(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ fontFamily: "'Noto Serif SC', serif", background: "#c0000a" }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Noto+Serif+SC:wght@400;600;700&display=swap');
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(18px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .anim-fadeup { animation: fadeUp 0.6s ease both; }
        @keyframes shimmer {
          0% { background-position: -200% center; }
          100% { background-position: 200% center; }
        }
        .btn-shimmer {
          background: linear-gradient(90deg, #f5a623 0%, #ffd700 40%, #f5a623 60%, #e8860a 100%);
          background-size: 200% auto;
          animation: shimmer 2.5s linear infinite;
        }
        @keyframes scrollUp {
          0% { transform: translateY(0); }
          100% { transform: translateY(-50%); }
        }
        @keyframes bounceMan {
          0%, 100% { transform: translateY(0px); }
          30% { transform: translateY(-14px); }
          50% { transform: translateY(-8px); }
          70% { transform: translateY(-18px); }
        }
        @keyframes bounceWoman {
          0%, 100% { transform: translateY(0px); }
          20% { transform: translateY(-16px); }
          45% { transform: translateY(-6px); }
          65% { transform: translateY(-20px); }
        }
        .bounce-man {
          animation: bounceMan 1.8s ease-in-out infinite;
        }
        .bounce-woman {
          animation: bounceWoman 1.8s ease-in-out infinite;
          animation-delay: 0.3s;
        }
        @keyframes marquee {
          0% { transform: translateX(100%); }
          100% { transform: translateX(-100%); }
        }
        .marquee-text {
          display: inline-block;
          white-space: nowrap;
          animation: marquee 12s linear infinite;
        }
      `}</style>

      {/* 顶部提示栏 - 跑马灯滚动 */}
      <div
        className="w-full overflow-hidden py-1.5 text-xs"
        style={{ background: "#8b0000", color: "#ffd700", letterSpacing: "0.05em" }}
      >
        <span className="marquee-text">
          内容纯属娱乐，暂不向未满18岁青少年提供服务&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;内容纯属娱乐，暂不向未满18岁青少年提供服务
        </span>
      </div>

      {/* 主内容 */}
      <main className="flex-1 flex flex-col items-center pb-6">

        {/* Banner 图 */}
        <div className="w-full relative anim-fadeup overflow-hidden" style={{ animationDelay: "0s" }}>
          {/* 背景 banner（隐藏原始小人，只保留背景和文字部分） */}
          <img
            src="https://xq3261.yunfankeji57.cn/static/index/index/banner.11cb2bff.png"
            alt="姻缘测试"
            className="w-full object-cover object-top"
            style={{ maxHeight: "280px", display: "block" }}
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = "none";
            }}
          />
          {/* 跳动的新郎小人（左侧叠加） */}
          <div
            className="absolute bottom-0 left-0 bounce-man"
            style={{ width: "28%", maxWidth: "110px" }}
          >
            <img
              src="https://xq3261.yunfankeji57.cn/static/index/index/man.png"
              alt="新郎"
              className="w-full h-auto object-contain object-bottom"
              onError={(e) => {
                (e.target as HTMLImageElement).style.display = "none";
              }}
            />
          </div>
          {/* 跳动的新娘小人（右侧叠加） */}
          <div
            className="absolute bottom-0 right-0 bounce-woman"
            style={{ width: "28%", maxWidth: "110px" }}
          >
            <img
              src="https://xq3261.yunfankeji57.cn/static/index/index/woman.png"
              alt="新娘"
              className="w-full h-auto object-contain object-bottom"
              onError={(e) => {
                (e.target as HTMLImageElement).style.display = "none";
              }}
            />
          </div>
          {/* fallback 标题（图片加载失败时显示） */}
          <div
            className="w-full py-12 text-center"
            style={{
              background: "linear-gradient(180deg, #8b0000 0%, #c0000a 100%)",
              display: "none",
            }}
            id="banner-fallback"
          >
            <h1
              className="text-5xl font-bold"
              style={{ color: "#ffd700", textShadow: "0 2px 12px rgba(0,0,0,0.5)", letterSpacing: "0.2em" }}
            >
              姻缘测试
            </h1>
          </div>
        </div>

        {/* 表单区域 */}
        <div
          className="w-full max-w-md mx-auto px-4 anim-fadeup"
          style={{ animationDelay: "0.15s", marginTop: "-2px" }}
        >
          <FortuneForm />
        </div>

        {/* 客服提示 */}
        <p
          className="text-xs text-center mt-3 px-4 anim-fadeup"
          style={{ color: "rgba(255,220,180,0.75)", animationDelay: "0.25s" }}
        >
          用户您好，订单/产品问题可通过点击页面内【客服】浮窗处理
        </p>

        {/* 滚动订单列表 */}
        <div className="w-full max-w-md mx-auto px-4 mt-4 anim-fadeup" style={{ animationDelay: "0.3s" }}>
          <ScrollOrders />
        </div>

        {/* 底部说明 */}
        <div
          className="w-full max-w-md mx-auto px-4 mt-5 text-center anim-fadeup"
          style={{ animationDelay: "0.4s" }}
        >
          <p className="text-xs mb-1" style={{ color: "rgba(255,220,180,0.6)" }}>
            需付费后方可查看结果，结果纯属娱乐仅供参考
          </p>
          <p className="text-sm font-bold" style={{ color: "#ffd700" }}>
            匠心打造精品在线测算
          </p>
        </div>

      </main>

      <Footer />
    </div>
  );
}
